var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.447 8.646l-.002-1.303-5.794.006-.005-5.794H7.344l.005 5.795-5.794.005v1.302l5.795-.005.005 5.794 1.302-.001-.005-5.794z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSmall);
export default __webpack_public_path__ + "static/media/plus-small.c761b424d113044c1082a5ac7a126665.svg";
export { ForwardRef as ReactComponent };